/* eslint-disable no-unused-vars */
/* eslint-disable eqeqeq */
import ButtonML from '@/components/button_ml/ButtonML';
import { useState, useEffect, useCallback } from 'react';
import styles from './action.less?modules';
import { useTrigger } from '@/utils/comHook.js';
import ModalML from '@/components/modal_ml/ModalML';
import ModalConfirmML from '@/components/modal_ml/modal_confirm_ml/ModalConfirmML';
import { ExclamationCircleOutlined } from '@ant-design/icons';
import { useDispatch, useSelector } from 'dva';
import { message } from 'antd';
import { toOption } from '@/utils/comUtil.js';
import { fieldType } from '@/constants.js';
import { history } from 'umi';
import EditModal from '@/containers/edit_modal/EditModal';
import { fieldPackageStatus } from '@/constants.js';

const baseInfo = {
  variableType: 'SYSTEM',
  fieldPackageId: history.location.query.id,
};
const Action = (props) => {
  const editTrigger = useTrigger();
  const deleteTrigger = useTrigger();
  const dispatch = useDispatch();
  const { singleListInfo, getTableOption } = props;
  const loadingEffect = useSelector((state) => state.loading);
  const loading = loadingEffect.effects['cfpmDetail/editField'];
  const { fetchData } = props;
  const [typeObj, setTypeObj] = useState({});
  const [cascaderData, setCascaderData] = useState({});
  // const [tableOption, setTableOption] = useState({});
  const [fieldModelOption, setFieldModelOption] = useState([]);
  const [singleInfo, setSingleInfo] = useState({});
  const [singleInfoInit, setSingleInfoInit] = useState({});

  // 条件查询列表
  const getFieldModel = useCallback(() => {
    dispatch({
      type: 'cfpmDetail/getFieldModel',
      payload: {},
      callback: (res) => {
        let result = [];
        let obj = {};
        let cascaderDataUnuse = {};
        let tableOptionUnuse = {};
        res &&
          res.length > 0 &&
          res.forEach((item) => {
            let child = [];
            item.modelFields.forEach((item2) => {
              child.push({
                value: item2.modelFieldId,
                label: item2.modelFieldName,
              });
              obj[item2.modelFieldId] = item2.modelFieldType;
              cascaderDataUnuse['a' + item2.modelFieldId] = [
                item.modelGroupName,
                item2.modelFieldId,
              ];
              tableOptionUnuse['a' + item2.modelFieldId] = item2.modelFieldName;
            });
            result.push({
              value: item.modelGroupName,
              label: item.modelGroupName,
              children: child,
            });
          });
        // 设置编辑页字段模型
        let infoinit = JSON.parse(JSON.stringify(singleListInfo));
        for (const key in cascaderDataUnuse) {
          if (singleListInfo.fieldModelId == key.substring(1)) {
            infoinit.fieldModelId = cascaderDataUnuse[key];
          }
        }
        getTableOption(tableOptionUnuse);
        setSingleInfo(infoinit);
        setSingleInfoInit(infoinit);
        setTypeObj(obj);
        setCascaderData(cascaderDataUnuse);
        // setTableOption(tableOptionUnuse);
        setFieldModelOption(result);
      },
    });
  }, [dispatch, singleListInfo]);

  // 发起请求
  useEffect(() => {
    getFieldModel();
  }, [getFieldModel]);

  const handleDelete = () => {
    deleteField(singleListInfo.id);
  };
  const deleteField = (id) => {
    dispatch({
      type: 'cfpmDetail/deleteField',
      payload: {
        id,
      },
      callback: (res) => {
        if (res && res.message) {
          message.error(res.message);
        } else {
          message.success('删除成功');
          fetchData();
          deleteTrigger.close();
        }
      },
    });
  };
  const editSingleField = (value, id) => {
    let valueUnuse = JSON.parse(JSON.stringify(value));
    if (value.fieldModelId) {
      valueUnuse.fieldModelId = value.fieldModelId[1];
    }
    dispatch({
      type: 'cfpmDetail/editField',
      payload: {
        values: {
          ...valueUnuse,
          ...baseInfo,
          id,
        },
      },
      callback: (res) => {
        if (res.code === 0) {
          message.success('编辑成功');
          fetchData();
          editTrigger.close();
        } else {
          setSingleInfo(Object.assign(value, { id }));
          message.error(res.message);
        }
      },
    });
  };

  // 字段模型改变调用
  const onChange = (e) => {
    // 设置模型选取格式
    let infoUnuse = JSON.parse(JSON.stringify(e || ''));
    infoUnuse.fieldType = typeObj[e.fieldModelId[1]];
    infoUnuse.id = singleListInfo && singleListInfo.id;
    setSingleInfo(infoUnuse);
  };

  const handleCancel = (e) => {
    editTrigger.close();
    setSingleInfo(singleInfoInit);
  };

  let formList = [
    {
      name: 'fieldName',
      type: 'input',
      label: '字段名称',
      required: true,
    },
    {
      name: 'variableName',
      type: 'input',
      label: '变量名',
      required: true,
    },
    {
      name: 'fieldModelId',
      type: 'cascader',
      label: '字段模型',
      required: true,
      allowClear: true,
      onChange: onChange,
      option: fieldModelOption,
    },
    {
      name: 'fieldType',
      type: 'select',
      label: '字段格式',
      required: true,
      disabled: Boolean(
        singleInfo.fieldModelId && singleInfo.fieldModelId.length > 0,
      ),
      option: toOption(fieldType),
    },
    {
      name: 'defaultValue',
      type: 'input',
      label: '默认值',
      required: true,
    },
    {
      name: 'exceptionValue',
      type: 'input',
      label: '异常值',
      required: true,
    },
    {
      name: 'description',
      type: 'input',
      label: '字段描述',
      required: true,
    },
    {
      name: 'fieldStatus',
      type: 'select',
      label: '状态',
      required: true,
      option: toOption(fieldPackageStatus),
    },
  ];
  return (
    <div className={styles.handle_btn}>
      <ButtonML
        size="large"
        // disabled={!singleListInfo.editable}
        value="编辑"
        onClick={editTrigger.open}
      />
      <ModalConfirmML
        title="是否确认删除?"
        handleOk={handleDelete}
        disabled={!singleListInfo.editable}
        handleCancel={deleteTrigger.close}
        visible={deleteTrigger.visible}
        value="删除"
        icon={<ExclamationCircleOutlined />}
      />
      <ModalML
        title="编辑"
        handleOk={editTrigger.open}
        handleCancel={handleCancel}
        visible={editTrigger.visible}
      >
        <EditModal
          handleCancel={handleCancel}
          // singleListInfo={singleListInfo}
          singleListInfo={singleInfo}
          // loading={loading}
          edit={editSingleField}
          formList={formList}
          // cRef={childRef}
        />
      </ModalML>
    </div>
  );
};
export default Action;
